import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { GenerationProvider } from './context/GenerationContext';
import LandingPage from './modules/landing/LandingPage';
import Login from './modules/auth/Login';
import Dashboard from './modules/dashboard/Dashboard';
import PrivateRoute from './modules/auth/PrivateRoute';
import './App.css';

import Editor from './modules/editor/Editor';

// Wrapper to provide key for Editor remount on canvas change
function EditorWrapper() {
  const { projectId } = useParams();
  return <Editor key={projectId} />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <GenerationProvider>
          <Router>
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/sign-in" element={<Login />} />
              <Route path="/login" element={<Navigate to="/sign-in" replace />} />

              {/* Protected routes */}
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/canvas/:projectId"
                element={
                  <PrivateRoute>
                    <EditorWrapper />
                  </PrivateRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </GenerationProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
